module.exports = __webpack_public_path__ + "img/233.kitchen_supplies.ffda365b.svg";